import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  useRef
} from "../../__snowpack__/pkg/react.js";
import {Input, message, Tag, Tooltip} from "../../__snowpack__/pkg/antd.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
import {IconClose, IconPlus} from "../../__snowpack__/pkg/@genieui-react/icon.js";
import LocaleContext from "../../__snowpack__/pkg/antd/es/locale-provider/context.js";
import {CaretUpOutlined, CaretDownOutlined} from "../../__snowpack__/pkg/@ant-design/icons.js";
import {isPlainObject} from "../../__snowpack__/pkg/lodash.js";
import IconHook from "../assets/icon_hook.svg";
import {useOnClickOutside} from "./Hooks/UseOnClickOut.js";
const messageDuration = 1.5;
const i18n = {
  "zh-cn": {
    alreadyExistMsg: "i18n: \u5DF2\u7ECF\u5B58\u5728",
    enterText: "i18n: \u8BF7\u8F93\u5165 (\u4F8B\u5982 \u7EA2\u8272)",
    maxLengthMsg: "i18n: \u8D85\u957F"
  },
  en: {
    alreadyExistMsg: "i18n: Already exist",
    enterText: "i18n: Enter a option (e.g.red)",
    maxLengthMsg: "i18n: Max Length"
  },
  id: {
    alreadyExistMsg: "i18n: Already exist",
    enterText: "i18n: Enter a option (e.g.red)",
    maxLengthMsg: "i18n: Max Length"
  }
};
export const InputSelectTags = (props) => {
  const {locale} = useContext(LocaleContext);
  const focusInputRef = useCallback((node) => {
    if (node !== null) {
      node.focus();
    }
  }, []);
  const [showSelect, setShowSelect] = useState(false);
  const ref = useRef(null);
  useOnClickOutside(ref, () => setShowSelect(false));
  const [state, setStateRaw] = useState({
    tags: [],
    inputVisible: false,
    inputValue: "",
    editInputIndex: -1,
    editInputValue: ""
  });
  const {options} = props;
  const getState = () => {
    return new Promise((resolve, reject) => {
      setStateRaw((state2) => {
        resolve(state2);
        return state2;
      });
    });
  };
  const setState = (state2) => {
    setStateRaw(state2);
    setTimeout(() => {
      props.onChange && props.onChange(state2.tags);
    });
  };
  useEffect(() => {
    setStateRaw({
      ...state,
      tags: [...props.value || []]
    });
  }, [props.value]);
  const handleClose = (removedTag) => {
    const tags2 = state.tags.filter((tag) => tag !== removedTag);
    setState({...state, tags: tags2});
  };
  const showInput = () => {
    setState({...state, inputVisible: true});
  };
  const handleInputChange = (e) => {
    setState({...state, inputValue: e.target.value});
  };
  const handleInputConfirm = () => {
    const {inputValue: inputValue2} = state;
    if (!inputValue2) {
      setState({
        ...state,
        inputValue: "",
        inputVisible: false
      });
      return;
    }
    if (props.maxLength && inputValue2.length > props.maxLength) {
      message.warn(props.maxLengthMsg || i18n[locale].maxLengthMsg, messageDuration);
      setState({
        ...state,
        inputValue: "",
        inputVisible: false
      });
      return;
    }
    if (tags.map((data) => data.value).indexOf(inputValue2) !== -1) {
      message.warn(props.alreadyExistMsg || i18n[locale].alreadyExistMsg, messageDuration);
      setState({
        ...state,
        inputValue: "",
        inputVisible: false
      });
      return;
    }
    setState({
      ...state,
      tags: [...tags, inputValue2],
      inputVisible: false,
      inputValue: ""
    });
  };
  const handleEditInputChange = (e) => {
    setState({...state, editInputValue: e.target.value});
  };
  const handleEditInputConfirm = async () => {
    const {tags: tags2, editInputIndex: editInputIndex2, editInputValue: editInputValue2} = await getState();
    if (!editInputValue2) {
      setState({
        ...state,
        editInputIndex: -1,
        editInputValue: ""
      });
      return;
    }
    if (props.maxLength && editInputValue2.length > props.maxLength) {
      message.warn(props.maxLengthMsg || i18n[locale].maxLengthMsg, messageDuration);
      setState({
        ...state,
        editInputIndex: -1,
        editInputValue: ""
      });
      return;
    }
    if (tags2.includes(editInputValue2)) {
      if (tags2.indexOf(editInputValue2) !== editInputIndex2) {
        message.warn(props.alreadyExistMsg || i18n[locale].alreadyExistMsg, messageDuration);
      }
      setState({
        ...state,
        editInputIndex: -1,
        editInputValue: ""
      });
      return;
    }
    const newTags = [...tags2];
    newTags[editInputIndex2] = {
      ...newTags[editInputIndex2],
      newValue: editInputValue2
    };
    setState({
      ...state,
      tags: newTags,
      editInputIndex: -1,
      editInputValue: ""
    });
  };
  const {
    tags,
    inputVisible,
    inputValue,
    editInputIndex,
    editInputValue
  } = state;
  const optionItemClick = (item) => {
    if (state.tags.map((data) => data.value).indexOf(item.value) != -1) {
      const tags2 = state.tags.filter((tag) => tag.value !== item.value);
      setState({...state, tags: tags2, editInputIndex: -1, editInputValue: ""});
    } else {
      const tags2 = [...state.tags, item];
      setState({...state, tags: tags2, editInputIndex: -1, editInputValue: ""});
    }
  };
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className: "input-tags",
    ref,
    id: props.id
  }, /* @__PURE__ */ React.createElement("div", {
    className: "input-tags-box"
  }, tags.map((tag, index) => {
    if (editInputIndex === index) {
      return /* @__PURE__ */ React.createElement(Input, {
        ref: focusInputRef,
        key: tag.value,
        size: "small",
        maxLength: 20,
        className: "tag-input",
        value: editInputValue,
        onChange: handleEditInputChange,
        onBlur: handleEditInputConfirm,
        onPressEnter: handleEditInputConfirm
      });
    }
    const newTag = isPlainObject(tag) ? tag.newValue || tag.value : tag;
    const isLongTag = newTag ? newTag.length > 20 : false;
    const tagElem = /* @__PURE__ */ React.createElement(Tag, {
      className: `edit-tag ${props.invalidTags?.includes(tag) && "edit-tag-invalid"}`,
      key: tag?.value,
      onClose: () => handleClose(tag),
      closable: !props.unCloseableTags?.includes(tag),
      closeIcon: !props.unCloseableTags?.includes(tag) ? /* @__PURE__ */ React.createElement(IconClose, {
        style: {width: 14, height: 14}
      }) : /* @__PURE__ */ React.createElement(React.Fragment, null)
    }, /* @__PURE__ */ React.createElement("span", {
      onDoubleClick: (e) => {
        if (!props.unCloseableTags?.includes(tag)) {
          setState({
            ...state,
            editInputIndex: index,
            editInputValue: tag.newValue || tag.value || tag
          });
          e.preventDefault();
        }
      }
    }, isLongTag ? `${(tag.newValue || tag.value || tag).slice(0, 20)}...` : tag ? tag.newValue || tag.value || tag : tag));
    return isLongTag ? /* @__PURE__ */ React.createElement(Tooltip, {
      title: tag.value,
      key: tag.value
    }, tagElem) : tagElem;
  }), inputVisible && !options && /* @__PURE__ */ React.createElement(Input, {
    ref: focusInputRef,
    type: "text",
    size: "small",
    className: "tag-input",
    value: inputValue,
    onChange: handleInputChange,
    onBlur: handleInputConfirm,
    onPressEnter: handleInputConfirm
  }), !inputVisible && !options && /* @__PURE__ */ React.createElement(Tag, {
    className: "tag-plus",
    onClick: showInput
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ant-tag-close-icon"
  }, /* @__PURE__ */ React.createElement(IconPlus, null)), /* @__PURE__ */ React.createElement("span", {
    className: "tag-plus-label"
  }, props.enterText || i18n[locale].enterText))), !tags || !tags.length && /* @__PURE__ */ React.createElement("span", {
    className: "select-cascader-picker-label",
    onClick: (e) => {
      setShowSelect(!showSelect);
    }
  }, props.enterText || i18n[locale].enterText), options && options.length && /* @__PURE__ */ React.createElement("div", {
    id: "myselect2",
    className: "select-input",
    onClick: (e) => {
      setShowSelect(!showSelect);
    }
  }, showSelect ? /* @__PURE__ */ React.createElement(CaretUpOutlined, null) : /* @__PURE__ */ React.createElement(CaretDownOutlined, null)), options && options.length && showSelect && /* @__PURE__ */ React.createElement("div", {
    className: "select-option-list",
    id: "myselect"
  }, options.map((_, index) => /* @__PURE__ */ React.createElement("div", {
    key: index,
    className: tags.map((data) => data.value).indexOf(_.value) != -1 ? "select-option-item select-option-item-active" : "select-option-item",
    onClick: () => {
      optionItemClick(_);
    }
  }, tags.map((data) => data.value).indexOf(_.value) != -1 ? /* @__PURE__ */ React.createElement("img", {
    src: IconHook,
    className: "select-option-item-active-hook"
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null), _.newValue || _.value))));
};
const Wrapper = styled.div`
  &.input-tags {
    /* display: flex;
    flex-wrap: wrap; */
    padding: 1px 4px;
    background: #ffffff;
    border-radius: 3px;
    border: 1px solid #adbacc;
    padding-bottom: 0;
    height: 28px;
    position: relative;
  }
  .select-cascader-picker-label {
    overflow: hidden;
    line-height: 24px;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #adbacc;
    margin-bottom: 3px;
    display: block;
    float: left;
    padding-left: 10px;
    cursor: pointer;
  }
  .select-input {
    cursor: pointer;
    height: 16px;
    text-align: right;
    display: block;
    padding-top: 4px;
    padding-right: 4px;
  }
  .input-tags-box {
    float: left;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .select-option-list {
    position: absolute;
    left: 0;
    right: 0;
    top: 30px;
    z-index: 999;

    height: 200px;
    background: #ffffff;
    overflow-y: auto;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    border: 1px solid #adbacc;
  }
  .select-option-item {
    color: #202d40;
    text-align: left;
    padding: 10px 16px;
    line-height: 14px;
    cursor: pointer;
    user-select: none;
  }
  .select-option-item:hover {
    background: #f2f4f6;
  }
  .select-option-item-active {
    background: #e3e8f0;
  }
  .select-option-item-active-hook {
    position: absolute;
    right: 40px;
  }
  .ant-tag {
    background: #f5f5f5;
    border-radius: 4px;
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #212b36;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3px;
    .ant-tag-close-icon {
      display: flex;
      width: 14px;
      height: 14px;
    }
  }
  .tag-plus {
    max-width: 100%;
    border-radius: 3px;
    border: 1px dashed #adbacc;
    background: #fff;
    .tag-plus-label {
      margin-left: 5px;
      display: block;
      font-size: 12px;
      font-family: SFProText-Medium, SFProText;
      font-weight: 500;
      color: #6020ff;
      line-height: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .tag-input {
    width: 78px;
    margin-bottom: 3px;
    margin-right: 8px;
  }
  .edit-tag-invalid {
    border: 1px solid #ff4d4f;
  }
`;
